<template>
    <div class="birthdate-picker">
        <form-group :label="label"
                    :errors="errors"
                    :name="name"
                    :required="required"
                    :required-text="requiredText"
                    label-for="birthdate"
        >
            <date-picker v-model="birthdate">
                <template v-slot="{ inputValue, togglePopover }">
                    <input :value="!!inputValue ? $formatDate(inputValue, format) : null"
                           :disabled="disabled"
                           :placeholder="inputPlaceholder"
                           :name="name"
                           readonly
                           class="birthdate-picker-input"
                           @focus="togglePopover()"
                    />
                </template>
            </date-picker>
        </form-group>
    </div>
</template>

<script>
import { DatePicker } from 'v-calendar';
import FormGroup from '../Holders/FormGroup';
import Translate from '../../../../Src/Modules/Localization/Translate';

export default {
    name: 'BirthdateSelect',
    components: {
        DatePicker,
        FormGroup
    },
    emits: [
        'change',
    ],
    props: {
        value: {},
        input: {},
        disabled: {
            type: Boolean,
            default: false
        },
        format: {
            type: String,
            default: 'YYYY-MM-DD'
        },
        name: {
            type: String,
            default: 'birthdate'
        },
        label: {
            type: String,
            default: Translate('words.birthdate')
        },
        inputPlaceholder: {
            type: String,
            default: Translate('placeholders.select_birthdate')
        },
        errors: {
            default: null
        },
        required: {
            type: Boolean,
            default: null
        },
        requiredText: {
            type: String,
            default: '*'
        },
    },
    computed: {
        birthdate: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('change', this.name, this.$formatDate(value, this.format));
            }
        },
    },
}
</script>